import api, { checkTokenErrorResponse } from '..';

export async function postEvent(titulo, descricao, hora_inicio, hora_fim, data, turma, bloquear) {
    return api.post("eventos/", {
        titulo,
        descricao,
        hora_inicio,
        hora_fim,
        data,
        turma,
        bloquear
    })
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getEvents(data = null) {
    return api.get(`eventos/${data ? `?data=${data}` : ''}`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function deleteEvent(eventId) {
    return api.delete(`eventos/${eventId}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

const eventServices = {
    postEvent,
    getEvents,
    deleteEvent,
}
export default eventServices;

